export default __webpack_public_path__ + "static/bloomberg-media-eb049e8c443d83c9c723ec6b555a8f11.webp";